'use strict';

var accentColors = require('../../../../../../../../../_virtual/accentColors.cjs');

(function (exports) {

	exports.AVIARY_ACCENTS = void 0;
	(function(AVIARY_ACCENTS) {
	    AVIARY_ACCENTS["forest"] = "forest";
	    AVIARY_ACCENTS["sand"] = "sand";
	})(exports.AVIARY_ACCENTS || (exports.AVIARY_ACCENTS = {}));
	
} (accentColors.__exports));
//# sourceMappingURL=accentColors.cjs.map
